<div #background [style.background]="lineBackground" width="100%" height="100%">
  
  <button #innerButton [wizTooltip]="fullDesc" width="100%" height="100%" [ngClass]="{'disabled-class': wizDisabled}"
    class="innerfocus-class" [disabled]='wizDisabled'
    (click)="onClick()" (dblclick)="onDoubleClick()" (focus)="wizOnFocus()">
      <div class="inner-button" width="100%">

          <wiz-image style="padding: 3px; object-fit: cover; border-radius: 3px; margin-right: 5px; padding-right: 5px; aspect-ratio: 1"
                    [hidden]="!wizImage"
                    #img
                    tabindex="0"
                    height="100%"
                    [sourceObservable]="wizImage">

          </wiz-image>

          <wiz-icon class="inner-icon" [hidden]="!wizIcon" style="margin-right: 5px; padding-right: 5px;" [style.color]="color">
            {{wizIcon}}</wiz-icon>
          <mat-icon [hidden]="!wizMaterial" 
          style="margin-right: 5px; padding-right: 5px; font-size: 20;"
          [style.color]="color">{{wizMaterial}}</mat-icon>
          <div class="label-container" width="100%">
            <wiz-label class="innerLabel" *ngIf="wizLabel"
              [style.color]="color"
              [wizLabel]="wizLabel" width="100%" [wizTextBehavior]="'truncate'"></wiz-label>
          </div>
          <div *ngIf="showDelete" class="clear-container" height="100%" >
            <mat-icon class="clear-icon" #innerClearIcon wizNotFocusable (click)="onClear($event)" width="10px" height="10px">close</mat-icon>
          </div>
      </div>
  </button>
</div>
